var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/modules/_html.js
// module id = ../../../node_modules/core-js/library/modules/_html.js
// module chunks = 0